
import { Component, Vue, Prop } from 'vue-property-decorator'

    @Component({
      name: 'ProgressBar'
    })
export default class ProgressBar extends Vue {
  // #region Props

        @Prop() progress!: number;
        @Prop() validated!: number;
        @Prop({ default: 'md' }) size!: string;

  // #endregion
}
